// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateModalVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isConfirmationModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_RATE_CONFIRMATION_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/reducers/confirmation-modal.js